import React from 'react';
import "./style.css";

const CalendarInfo = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: "calendarInfo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "calendarInfo_flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info clientInfo"
  }), /*#__PURE__*/React.createElement("p", null, "Client")), /*#__PURE__*/React.createElement("div", {
    className: "calendarInfo_flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info expertInfo"
  }), /*#__PURE__*/React.createElement("p", null, "Expert")), /*#__PURE__*/React.createElement("div", {
    className: "calendarInfo_flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info matchInfo"
  }), /*#__PURE__*/React.createElement("p", null, "Match")), /*#__PURE__*/React.createElement("div", {
    className: "calendarInfo_flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info scheduledInfo"
  }), /*#__PURE__*/React.createElement("p", null, "Scheduled")));
};

export default CalendarInfo;